module.exports = __webpack_public_path__ + "static/media/signature.cf0062df.jpg";